#import "../fragments/contact-page-fragment.graphql"

mutation UpdateContactCustomFieldValue($contact: ContactUpdateInputFieldInput!) {
    contactUpdate(input: {contact: $contact}) {
        contact {
            ...ContactPageFragment
        }
    }
}
